<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <!-- <a class="logo" href="#" (click)="navigateHome()"><span><img src="../../assets/images/Airlinegstlogo.png"
          style="width: 100%;" /></span></a> -->
    <a class="logo" href="#" (click)="navigateHome()"><span><img src="../../assets/images/Airlinegstlogo.png"
          style="width: 100%;" /></span></a>
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
  <!-- <button outline status="primary" class="back-btn" (click)="gotoPreviousPage()">
    <nb-icon class="fa fa-arrow-left" pack="font-awesome"></nb-icon> Back
  </button> -->
</div>

<div class="header-container">
  <form [formGroup]="headerForm" class="form-valide">
    <div *ngIf="isGroupedCompany">
      <nb-select placeholder="Select Company" [size]="'small'" fullWidth formControlName="Companies" nbSelect
        [(ngModel)]="selectedCompany" (selectedChange)="onCompanyChange($event)">
        <nb-option *ngFor="let item of companiesArr" [value]="item.userId">
          {{item.customerName}}
        </nb-option>
      </nb-select>
    </div>
  </form>

  <nb-actions size="small">
    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <!-- <nb-action class="control-item" id="notiBellIcon" style="display: block;" icon="bell-outline" [badgeText]="NofCnt"
      badgeStatus="warning" (click)="showNotification()"></nb-action> -->
    <nb-action class="control-item fa fa-book usermanual" style="display: block;" icon="" badgeStatus="warning"
      (click)="gotoUserManual()" title="User manual">
    </nb-action>
    <nb-action class="control-item" style="display: block;" icon="question-mark-circle-outline" badgeStatus="warning"
      (click)="gotoFAQ()" title="FAQ">
    </nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user *ngIf="isLoginUser" [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="user?.name"
        [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>